<template>
  <div class="login">
	  <!-- 找回密码 -->
    <div class="masking" v-if="code" @click="closeMasking"></div>
    <div class="top">
      <!-- <div class="logo"></div> -->
      <div class="title" @click="toLogin">
        <p class="big">中小学教师网络法治教育培训项目</p>
        <!-- <p class="small">2020国培计划</p> -->
      </div>
      <!-- <div class="contact"  @mouseover="showCode">
        <span class="text">关注我们</span>
        <img src="../assets/images/wechat.png" alt="联系我们">
        <div class="code" v-if="code">
          <img class="code_bg" src="../assets/images/code_bg.png" alt="">
          <img class="qrcode" src="../assets/images/code.png" alt="">
        </div>
      </div> -->
    </div>
    <div class="login_content">
      <div class="path" v-if="step != 3">
        <div :class="step == 0 ? 'list checked' : 'list'">
          <img v-show="step != 0" src="../assets/images/mobile_accountG.png" alt="">
          <img v-show="step == 0" src="../assets/images/mobile_accountB.png" alt="">
          <p>输入账号</p>
        </div>
        <div class="line"></div>
        <div :class="step == 1 ? 'list checked' : 'list'">
          <img v-show="step != 1" src="../assets/images/mobile_phoneG.png" alt="">
          <img v-show="step == 1" src="../assets/images/mobile_phoneB.png" alt="">
          <p>验证手机号</p>
        </div>
        <div class="line"></div>
        <div :class="step == 2 ? 'list checked' : 'list'">
          <img v-show="step != 2" src="../assets/images/mobile_passwordG.png" alt="">
          <img v-show="step == 2" src="../assets/images/mobile_passwordB.png" alt="">
          <p>重置密码</p>
        </div>
      </div>
      <div class="content">
        <div class="step" v-if="step == 0">
          <div class="input" style="margin-top: 0.5rem;">
            <input class="account" type="text" placeholder="输入身份证号码或手机号" v-model="account">
          </div>
          <p class="account_intro">为了您的账户安全，请进行安全验证</p>
          <div class="drag" ref="dragDiv">
            <div class="drag_bg"></div>
            <div class="drag_text">{{confirmWords}}</div>
            <div ref="moveDiv" @mousedown="mousedownFn($event)" :class="{'handler_ok_bg':confirmSuccess}+' handler handler_bg'" style="position: absolute;top: 0px;left: 0px;"></div>
           </div>
          <div class="btn" @click="checkAccount();">下一步</div>
        </div>
        <div class="step" v-if="step == 1">
          <p class="phone_intro">手机号：{{ account_text }}</p>
          <div class="input">
            <input class="captcha" type="text" placeholder="请输入验证码" v-model="captcha">
            <span class="code_text" @click="getCode" v-if="!click_status && code_text == '获取短信验证码'">
              <span v-if="click_status">{{sec}}</span>{{code_text}}
            </span>

            <span class="code_text" v-if="click_status"
             style="color: #fff;background-color: #949494;border-color: #949494;">
              <span v-if="click_status">{{sec}}</span>{{code_text}}
            </span>

            <span class="code_text" @click="getCode" v-if="!click_status && code_text == '重新发送验证码'"
             style="color: #ff6600;background-color: #fff;border-color: #ff6600;">
              <span v-if="click_status">{{sec}}</span>{{code_text}}
            </span>

          </div>
          <div class="btn" @click="checkCode();">下一步</div>
        </div>
        <div class="step" v-if="step == 2">
          <div class="input" style="margin-top: 0.8rem;font-size: 18px;color: red;font-weight:bold;">
          <div>点击确认后，您的密码将重置为初始密码，即身份证后6位。</div>
          </div>

          <div class="btn" @click="submit();" style="margin-left: 20%">确认操作</div>
        </div>
        <div class="step" v-if="step == 3">
          <img class="icon" src="../assets/images/eval_ok.png" alt="">
          <p class="result">密码重置成功</p>
          <p class="tips">页面将在60s钟内自动跳转登录</p>
          <div class="tologin" @click="toLogin();">页面没有跳转，点击去登录</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  data () {
    return {
      step:0,
      account:'',
      captcha:'',
      newpassword:'',
      repassword:'',
      code:false,
      account_text:'',

      sec:60,
      code_text:'获取短信验证码',
      click_status:false,
      interval_id:false,

      beginClientX:0,   /*距离屏幕左端距离*/
      mouseMoveStata:false,  /*触发拖动状态 判断*/
      maxwidth:'',    /*拖动最大宽度，依据滑块宽度算出来的*/
      confirmWords:'拖动滑块验证', /*滑块文字*/
      confirmSuccess:false   /*验证成功判断*/

    }
  },
  mounted(){
   this.maxwidth = this.$refs.dragDiv.clientWidth - this.$refs.moveDiv.clientWidth;
   document.getElementsByTagName('html')[0].addEventListener('mousemove',this.mouseMoveFn);
   document.getElementsByTagName('html')[0].addEventListener('mouseup',this.moseUpFn)
  },
	methods:{
    getCode(){
      var _this = this;
      if(this.click_status){
        return ;
      }
      var params = {
        mobile:this.account,
      }
      this.post('/getcode',params,(data)=>{
        console.log(data);
        _this.$mResToast({
          type:data.status == 200 ? 'success' : 'error',
          msg:data.msg,
          duration:3000,
          isIcon:true,
        });
        if(data.status != 200) return;
        _this.click_status = true;
        _this.code_text = 'S';
        _this.interval_id = setInterval(()=>{
          if(_this.sec > 1){
            _this.sec--;
          }else{
            _this.sec = 60;
            _this.click_status = false;
            _this.code_text = '重新发送验证码';
            clearInterval(_this.interval_id);
          }
        },1000);
      })
    },
    checkAccount(){
      var _this = this;
      console.log(this.mouseMoveStata);
      if(!this.account){
        _this.$mResToast({
          type:'error',
          msg:'请输入身份证号或手机号',
          duration:3000,
          isIcon:true,
        });
        return;
      }
      if(!this.mouseMoveStata){
        _this.$mResToast({
          type:'error',
          msg:'请先完成验证',
          duration:3000,
          isIcon:true,
        });
        return;
      }
      var params = {
        loginInfo:this.account,
      }
      this.post('/findpass',params,(data)=>{
        console.log(data);
        if(data.status == 200){
          var reg = /^(\d{3})\d{4}(\d{4})$/;
          _this.account_text = _this.account.replace(reg, '$1****$2');
          _this.toNext(1);
        }else{
          _this.$mResToast({
            type:'error',
            msg:data.msg,
            duration:3000,
            isIcon:true,
          });
        }
      })
    },
    checkCode(){
      var _this = this;
      var params = {
        mobile:this.account,
        code:this.captcha,
      }
      this.post('/checkcode',params,(data)=>{
        console.log(data);
        if(data.status == 200){
          _this.toNext(2);
        }else{
          _this.$mResToast({
            type:'error',
            msg:data.msg,
            duration:3000,
            isIcon:true,
          });
        }
      })
    },
    toNext(index){
      this.step = index;
    },
    toLogin(){
      this.$router.replace('/Login');
    },
    submit(){
      var _this =this;

      var params = {
        firstPass:this.newpassword,
        secondPass:this.repassword,
        code:this.captcha,
        mobile:this.account,
      }
      this.post('/resetpass',params,(data)=>{
        console.log(data);
        if(data.status == 200){
         _this.step = 3;
         setTimeout(function(){
           _this.toLogin();
         },3000)
        }
      })
    },
    mousedownFn:function (e) {
      if(!this.confirmSuccess){
       e.preventDefault && e.preventDefault(); //阻止文字选中等 浏览器默认事件
       this.mouseMoveStata = true;
       this.beginClientX = e.clientX;
      }
    },  //mousedoen 事件
     successFunction(){
      this.confirmSuccess = true
      this.confirmWords = '验证通过';
      if(window.addEventListener){
       document.getElementsByTagName('html')[0].removeEventListener('mousemove',this.mouseMoveFn);
       document.getElementsByTagName('html')[0].removeEventListener('mouseup',this.moseUpFn);
      }else {
       document.getElementsByTagName('html')[0].removeEventListener('mouseup',()=>{});
      }
      document.getElementsByClassName('drag_text')[0].style.color = '#fff'
      document.getElementsByClassName('handler')[0].style.left = this.maxwidth + 'px';
      document.getElementsByClassName('drag_bg')[0].style.width = this.maxwidth + 'px';
     },    //验证成功函数
     mouseMoveFn(e){
      if(this.mouseMoveStata){
       let width = e.clientX - this.beginClientX;
       if(width>0 && width<=this.maxwidth){
        document.getElementsByClassName('handler')[0].style.left = width + 'px';
        document.getElementsByClassName('drag_bg')[0].style.width = width + 'px';
       }else if(width>this.maxwidth){
        this.successFunction();
       }
      }
     },     //mousemove事件
     moseUpFn(e){
      this.mouseMoveStata = false;
      var width = e.clientX - this.beginClientX;
      if(width<this.maxwidth){
       document.getElementsByClassName('handler')[0].style.left = 0 + 'px';
       document.getElementsByClassName('drag_bg')[0].style.width = 0 + 'px';
      }
     },      //mouseup事件
     closeMasking(){
       this.code = false;
     },
     showCode(){
       this.code = true;
     },
	}
}
</script>

<style scoped>
.masking{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0,0,0,0.7);
  z-index: 20;
}


.drag{
  position: relative;
  background-color: #e8e8e8;
  width: 400px;
  height: 0.37rem;
  line-height: 0.37rem;
  text-align: center;
  margin-top: 0.24rem;
 }
 .handler{
  width: 40px;
  height: 32px;
  border: 1px solid #ccc;
  cursor: move;
 }
 .handler_bg{
  background: #fff url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NTEyNTVEMURGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NTEyNTVEMUNGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo2MTc5NzNmZS02OTQxLTQyOTYtYTIwNi02NDI2YTNkOWU5YmUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+YiRG4AAAALFJREFUeNpi/P//PwMlgImBQkA9A+bOnfsIiBOxKcInh+yCaCDuByoswaIOpxwjciACFegBqZ1AvBSIS5OTk/8TkmNEjwWgQiUgtQuIjwAxUF3yX3xyGIEIFLwHpKyAWB+I1xGSwxULIGf9A7mQkBwTlhBXAFLHgPgqEAcTkmNCU6AL9d8WII4HOvk3ITkWJAXWUMlOoGQHmsE45ViQ2KuBuASoYC4Wf+OUYxz6mQkgwAAN9mIrUReCXgAAAABJRU5ErkJggg==") no-repeat center;
 }
 .handler_ok_bg{
  background: #fff url("../assets/images/mobile_check.png") no-repeat center;
 }
 .drag_bg{
  background-color: #7ac23c;
  height: 0.37rem;
  width: 0px;
 }
 .drag_text{
  font-size: 0.21rem;
  color: #fff;
  position: absolute;
  top: 0px;
  width: 100%;
  text-align: center;
  -moz-user-select: none;
  -webkit-user-select: none;
  user-select: none;
  -o-user-select:none;
  -ms-user-select:none;
 }


.login{
  width: 100%;
}
.top{
  width: 15rem;
  height: 1.54rem;
  margin: 0 auto;
}
.logo{
  width: 0.79rem;
  height: 0.61rem;
  float: left;
  background-color: blue;
  margin: 0.25rem 0.24rem 0.3rem 0;
}
.title{
 float: left;
 width: 10rem;
}
.big{
  float: left;
  width: 10rem;
  font-size: 0.5rem;
  color: #0073d3;
  height: 0.5rem;
  line-height: 0.5rem;
  margin-top:0.4rem;
}
.small{
  float: left;
  width: 10rem;
  font-size: 0.25rem;
  color: #989898;
  height: 0.25rem;
  line-height: 0.25rem;
  margin-top: 0.28rem;
}
.contact{
  float: right;
  width: 2.1rem;
  height: 0.56rem;
  margin: 0.34rem 0.07rem 0 0;
  position: relative;
  cursor: pointer;
}
.contact span{
  font-size: 0.25rem;
  color: #989898;
  line-height: 0.56rem;
  float: left;
}
.contact img{
  width: 0.56rem;
  height: 0.56rem;
  margin-left: 0.3rem;
  float: left;
}

.code{
  width: 2.11rem;
  height: 2.13rem;
  position: absolute;
  top: 0.6rem;
  right: 0.2rem;
  z-index: 30;
}
.code .code_bg{
  float: left;
  width: 2.11rem;
  height: 2.13rem;
  margin: 0;
}
.code .qrcode{
  width: 1.77rem;
  height: 1.69rem;
  position: absolute;
  left: 50%;
  top: 0.31rem;
  transform: translate(-50%,0);
  margin: 0;
}


.login_logo{
  width: 15rem;
  height: 7.45rem;
  position: relative;
}
.login_logo img{
  width: 100%;
  height: 100%;
  position: absolute;
}
.login_content{
  width: 6rem;
  height: 4rem;
  margin: 1.7rem auto 2rem auto;
  position: relative;
}
.path{
  width: 100%;
  height: 1rem;
}
.path .list{
  width: 1.3rem;
  height: 100%;
  float: left;
  margin: 0 0.1rem;
}
.path .list img{
  width: 0.54rem;
  height: 0.54rem;
  display: block;
  margin: 0 auto;
}
.path .line{
  width: 0.6rem;
  height: 0.85rem;
  border-bottom: 0.03rem dashed #7f7f7f;
  float: left;
}
.path .list p{
  float: left;
  width: 100%;
  font-size: 0.25rem;
  height: 0.26rem;
  line-height: 0.26rem;
  color: #7f7f7f;
  text-align: center;
  margin-top: 0.17rem;
}
.path .checked{
  border-color: #49d639;
}
.path .checked p{
  color: #49d639;
}

.content{
  padding-left: 0.2rem;
}
.content .step{

}
.content .step .input{
  width: 100%;
  height: 0.5rem;
}
.content .step input{
  float: left;
  width: 3.4rem;
  height: 0.45rem;
  outline: none;
  border: 0.01rem solid #8b8b8b;
  padding: 0 0.1rem;
  border-radius: 0.1rem;
  font-size: 0.21rem;
  color: #bcbcbc;
}
.content .step input::placeholder{
  font-size: 0.21rem;
  color: #bcbcbc;
}
.content .step .btn{
  width: 2.15rem;
  height: 0.48rem;
  font-size: 0.24rem;
  color: #fff;
  background-color: #2b73cc;
  text-align: center;
  line-height: 0.48rem;
  margin-top: 0.47rem;
  cursor: pointer;
}
.content .step .account_intro{
  margin-top: 0.34rem;
}
.content .step p{
  font-size: 0.17rem;
  color: #7c7c7c;
}
.content .step .phone_intro{
  font-size: 0.25rem;
  color: #7c7c7c;
  margin-top: 1rem;
  margin-bottom: 0.2rem;
}
.content .step .captcha{
  float: left;
  width: 3.4rem;
  height: 0.45rem;
}
.content .step .code_text{
  float: left;
  font-size: 0.17rem;
  color: #19cd00;
  width: 1.41rem;
  height: 0.32rem;
  line-height: 0.32rem;
  text-align: center;
  border: 0.01rem solid #19cd00;
  margin: 0.05rem 0.17rem;
  cursor: pointer;
}
.content .step .icon{
  width: 0.72rem;
  height: 0.72rem;
  display: block;
  margin: 0 auto;
}
.content .step .result{
  font-size: 0.25rem;
  color: #7f7f7f;
  text-align: center;
  margin-top: 0.33rem;
}
.content .step .tips{
  font-size: 0.21rem;
  color: #bcbcbc;
  text-align: center;
  margin-top: 1.3rem;
}
.content .step .tologin{
  width: 3.44rem;
  height: 0.48rem;
  margin: 0 auto;
  font-size: 0.24rem;
  color: #fff;
  background-color: #2b73cc;
  text-align: center;
  line-height: 0.48rem;
  margin-top: 0.47rem;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Mobile.vue